export const MEMBERSHIP_STATUS = {
  activated: "ACTIVATED",
  pendingToCollect: "PENDING_TO_COLLECT",
  pendingToActivate: "PENDING_TO_ACTIVATE",
  expired: "EXPIRED",
  deactivated: "DEACTIVATED",
} as const;
